export const LifeEvents = {
    0: "Death",
    1: "Relocation",
    // 2: "Majority",
    // 3: "Marriage",
    // 4: "Birth",
    // 5: "Divorce"
};

export const FrenchLifeEvents = (val) => {
    let value = "";
    switch (val) {
        case "Death":
        default:
            value = "Succession";
            break;
        case "Relocation":
            value = "Déménagement";
            break;
        case "Majority":
            value = "Passage majorité";
            break;
        case "Marriage":
            value = "Mariage";
            break;
        case "Birth":
            value = "Naissance";
            break;
        case "Divorce":
            value = "Divorce";
            break;
    }

    return value;
}